var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;

/**
 * Convert any color format into RGBA.
 *
 * @param Color Color
 *
 * @return RGBA color object.
 */
var toRgbColor = function toRgbColor(color) {
  if (color.match(hexRegex)) {
    return {
      red: parseInt("".concat(color[1]).concat(color[2]), 16),
      green: parseInt("".concat(color[3]).concat(color[4]), 16),
      blue: parseInt("".concat(color[5]).concat(color[6]), 16)
    };
  }
  if (color.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("".concat(color[7]).concat(color[8]), 16) / 255).toFixed(2));
    return {
      red: parseInt("".concat(color[1]).concat(color[2]), 16),
      green: parseInt("".concat(color[3]).concat(color[4]), 16),
      blue: parseInt("".concat(color[5]).concat(color[6]), 16),
      alpha: alpha
    };
  }
  if (color.match(reducedHexRegex)) {
    return {
      red: parseInt("".concat(color[1]).concat(color[1]), 16),
      green: parseInt("".concat(color[2]).concat(color[2]), 16),
      blue: parseInt("".concat(color[3]).concat(color[3]), 16)
    };
  }
  if (color.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("".concat(color[4]).concat(color[4]), 16) / 255).toFixed(2));
    return {
      red: parseInt("".concat(color[1]).concat(color[1]), 16),
      green: parseInt("".concat(color[2]).concat(color[2]), 16),
      blue: parseInt("".concat(color[3]).concat(color[3]), 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(color);
  if (rgbMatched) {
    return {
      red: parseInt("".concat(rgbMatched[1]), 10),
      green: parseInt("".concat(rgbMatched[2]), 10),
      blue: parseInt("".concat(rgbMatched[3]), 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(color);
  if (rgbaMatched) {
    return {
      red: parseInt("".concat(rgbaMatched[1]), 10),
      green: parseInt("".concat(rgbaMatched[2]), 10),
      blue: parseInt("".concat(rgbaMatched[3]), 10),
      alpha: parseFloat("".concat(rgbaMatched[4]))
    };
  }
  return {
    red: 0,
    green: 0,
    blue: 0
  };
};
var propertyColorToRgbString = function propertyColorToRgbString(propertyColor) {
  var rgbValue = toRgbColor(propertyColor);
  return "".concat(rgbValue.red, ", ").concat(rgbValue.green, ", ").concat(rgbValue.blue);
};

export { toRgbColor as default, propertyColorToRgbString };
//# sourceMappingURL=toRgbColor.js.map
